import React from "react"
import './App.css';
import Dictionary from "./Dictionary"

export default function App() {
  return (
    <div className="App">
      <Dictionary />
      <footer>
        <a href="https://github.com/Anna-Mamedova" target="_blank" rel="noreferrer">My GitHub</a>
      </footer>
    </div>
  );
}